import { render, staticRenderFns } from "./validation.vue?vue&type=template&id=31e87c6c&scoped=true&"
import script from "./validation.vue?vue&type=script&lang=js&"
export * from "./validation.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/style.css?vue&type=style&index=0&id=31e87c6c&prod&scoped=true&lang=css&"
import style1 from "./validation.vue?vue&type=style&index=1&id=31e87c6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e87c6c",
  null
  
)

export default component.exports